<div class="on-map-page-wrapper">
  <div class="on-map-page-wrapper__buttons">
    <ng-container *ngTemplateOutlet="poiButtons"></ng-container>
  </div>
  @if ((isMapVisible$ | async) === true && tripMarkers()) {
    <app-map
      [id]="mapId"
      class="on-map-page-wrapper__map"
      [showRouteMarkers]="showRouteMarkers"
      [markers]="tripMarkers()"
      [customTemplate]="{
        template: poiButtons,
        isFullScreenTemplate: true,
      }"
      [invalidateSize$]="splitterEvents.resizeEnd$"></app-map>
  }
</div>

<ng-template #poiButtons>
  <div class="on-map-page-wrapper__buttons">
    <dv-button
      [icon]="'map_marker_add'"
      (click)="getAddress(dialogType.StartPOI)"
      [disabled]="isFetchInProgress || (hasEditPermissions$ | async) === false">
      {{ 'TripOnMapTab.AddStartPOI' | translate | uppercase }}
    </dv-button>
    <dv-button
      [icon]="'map_marker_add'"
      (click)="getAddress(dialogType.EndPOI)"
      [disabled]="isFetchInProgress || (hasEditPermissions$ | async) === false">
      {{ 'TripOnMapTab.AddEndPOI' | translate | uppercase }}
    </dv-button>
  </div>
</ng-template>
